import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import AddSubCategory from '@features/measurement/components/AddSubCategory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import {
	addCategoryWiseMarketAndFabricType,
	createRangePlanCategory,
	fetchAllCategoryWiseSubCategoryList,
	updateSubcategory
} from '@services/measurementService';
import { fetchDepartments, fetchFabricCategory } from '@services/commonService';

import { checkUserType } from '@utils/Util';

const CategoryWiseSubCategoryModal = ({ selectedItem, onClose, onFetchData }) => {
	const [subCategoryList, setSubCategoryList] = useState([]);
	const [disabledSubCategoryList, setDisabledSubCategoryList] = useState([]);
	const [actionValue, setActionValue] = useState(null);
	const [filteredSubCategoryList, setFilteredSubCategoryList] = useState([]);
	const [markets, setMarkets] = useState([]);
	const [fabricTypes, setFabricTypes] = useState([]);
	const [selectedMarket, setSelectedMarket] = useState([]);
	const [selectedFabric, setSelectedFabric] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const fetchMarketAndCategories = async () => {
		try {
			dispatch(openLoader());
			const marketData = await fetchDepartments();
			const fabricType = await fetchFabricCategory();
			setMarkets(marketData?.map((item) => ({ label: item.name, value: item.id })));
			setFabricTypes(fabricType?.map((item) => ({ label: item.value, value: item.code })));
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchMarketAndCategories();
		onFetchSubcategory();
		if (selectedItem?.fabricTypeList?.length > 0) {
			setSelectedFabric(selectedItem.fabricTypeList?.map((item) => ({ label: item, value: item })));
		}
		if (selectedItem?.productGroupList?.length > 0) {
			setSelectedMarket(
				selectedItem.productGroupList?.map((item) => ({ label: item.name, value: item.id }))
			);
		}
	}, [selectedItem]);

	const onFetchSubcategory = async () => {
		try {
			dispatch(openLoader());
			const data = await fetchAllCategoryWiseSubCategoryList(selectedItem?.id);
			setSubCategoryList(data?.filter((item) => !item?.isDisabled));
			setFilteredSubCategoryList(data?.filter((item) => !item?.isDisabled));
			setDisabledSubCategoryList(data?.filter((item) => item?.isDisabled));
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const onUpdateSubCategory = async (bodyData) => {
		try {
			let body = bodyData;
			if (
				bodyData?.documentDTO?.docUrl ||
				bodyData?.documentResponse?.docUrl ||
				(bodyData?.documentDTO && Object.keys(bodyData.documentDTO).length === 0) ||
				(bodyData?.documentResponse && Object.keys(bodyData.documentResponse).length === 0)
			) {
				delete body.documentDTO;
				delete body.documentResponse;
			}
			dispatch(openLoader());
			const data = await updateSubcategory(body, body?.id);
			if (data.message) {
				toastSuccess(data.message);
			}
			onddSuccess();
			dispatch(closeLoader());
			return data;
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};
	const onddSuccess = () => {
		onFetchSubcategory();
		setActionValue(null);
	};

	const onSearchTemplates = (e) => {
		setSearchValue(e.target.value);
		let searchResult = e.target.value
			? subCategoryList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: subCategoryList;
		setFilteredSubCategoryList(searchResult);
	};

	const toggleSubCategoryAsHiddenCategory = async (item) => {
		try {
			dispatch(openLoader());
			await createRangePlanCategory(selectedItem?.id, item.id);
			onddSuccess();
		} finally {
			dispatch(closeLoader());
		}
	};

	const renderEditItems = (item, isMaincatgory) =>
		checkUserType('ADMIN') && (
			<div className="edit-items">
				<div className="option">
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							id="menu1"
							data-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={`${process.env.PUBLIC_URL}/icons/more_vertical.svg`} alt="tee" />
						</button>
						<ul
							className="dropdown-menu dropdown-menu-right shadow-lg"
							role="menu"
							aria-labelledby="menu1"
							x-placement="bottom-end"
						>
							<li
								role="presentation"
								className="px-4 pb-3 pt-3"
								onClick={() => setActionValue(item)}
							>
								<span role="menuitem" className="font-weight-normal  text-black">
									Edit
								</span>
							</li>
							{!isMaincatgory && (
								<li
									role="presentation"
									className="px-4 pb-3 pt-3"
									onClick={() => toggleSubCategoryAsHiddenCategory(item)}
								>
									<span role="menuitem" className="font-weight-normal  text-black">
										{item?.isRangePlanCategory ? 'Hide' : 'Show'} it in the range plan
									</span>
								</li>
							)}
							{!isMaincatgory && (
								<li
									role="presentation"
									className="px-4 pb-3"
									onClick={() =>
										onUpdateSubCategory({
											...item,
											isDisabled: true
										})
									}
								>
									<span role="menuitem" className="font-weight-normal  text-black red">
										Disable
									</span>
								</li>
							)}
						</ul>
					</div>
				</div>
			</div>
		);

	const getMainCategory = () => filteredSubCategoryList?.find((item) => item?.isPrimary) || null;

	const parentCategoryImage = () =>
		getMainCategory()?.documentResponse?.docUrl ?? process.env.PUBLIC_URL + '/icons/pom/t-shirt.png';

	const onChangeMultiSelect = (selected, fieldName) => {
		if (fieldName === 'selectedFabrics') {
			setSelectedFabric(selected);
		} else if (fieldName === 'selectedMarket') {
			setSelectedMarket(selected);
		}
	};

	const handleSave = async () => {
		try {
			dispatch(openLoader());
			const requestBody = {
				productGroupIdList: selectedMarket?.map((item) => item.value) || [],
				fabricTypeList: selectedFabric?.map((item) => item.value) || []
			};
			await addCategoryWiseMarketAndFabricType(requestBody, selectedItem.id);
			await onFetchData();
			toastSuccess('Category wise market and fabric type updated successfully');
		} finally {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer className="category-pom-modal">
			<div className="common-popup category-pom-modal width-784">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte d-flex align-items-center">
						<h3 className="semibold-16 mb-0">{selectedItem?.name}</h3>
						<span className="pl-2 middle-border regular-12">|</span>
						<span className="pl-2 gray_dark_02 regular-12">
							Sub-category {filteredSubCategoryList?.length}
						</span>
					</div>
					<div className="close-btn" onClick={() => onClose()}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body label-y-scroll">
					<div className="d-flex justify-content-between category-search">
						<div className="add-new-design">
							{checkUserType('ADMIN') && (
								<button
									className="button text size32 px-0"
									onClick={() => setActionValue('ADD')}
								>
									<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
									<span className="ml-1">Add Sub Category</span>
								</button>
							)}
						</div>
						<div className="form-group size32 m-0 search-filter filter-with-animation">
							<div className="with-icon right-icon">
								<input
									type="text"
									placeholder="Search"
									name="name"
									onChange={onSearchTemplates}
									value={searchValue}
								/>
								<span className="right-icon">
									<img
										src={`${process.env.PUBLIC_URL}/icons/search-dark.svg`}
										alt="search"
									/>
								</span>
							</div>
						</div>
					</div>
					<div className="sub-category-chip d-flex align-items-center gap-4">
						<div className="w-100">
							<div className="form-group no-shadow-react-select">
								<label>Market*</label>
								<Select
									onChange={(selected) => onChangeMultiSelect(selected, 'selectedMarket')}
									value={selectedMarket}
									name="market"
									isMulti
									options={markets}
								/>
							</div>
						</div>
						<div className="w-100">
							<div className="form-group no-shadow-react-select">
								<label>Fabric Type</label>
								<Select
									onChange={(selected) => onChangeMultiSelect(selected, 'selectedFabrics')}
									value={selectedFabric}
									name="fabricType"
									isMulti
									options={fabricTypes}
								/>
							</div>
						</div>
						<div>
							<div className="form-group mb-0 mt-1">
								<button className="button size32" onClick={handleSave}>
									Save
								</button>
							</div>
						</div>
					</div>
					<div className="measurement-category-items">
						<div className="configuration-single active d-flex justify-content-between align-items-center align-self-center">
							<div
								className=" d-flex justify-content-start"
								onClick={() => navigate(`/pom-tag-list/${getMainCategory()?.id}`)}
							>
								<div className="dress-img">
									<img src={parentCategoryImage()} alt="tee" />
									<div className="hover-img">
										<img src={parentCategoryImage()} alt="tee" />
									</div>
								</div>
								<div className="configuration-title d-flex justify-content-center align-self-center">
									<p className="p-0 m-0 regular-14 weight-600 gray_dark_01">
										{getMainCategory()?.name}
										(All)
									</p>
								</div>
							</div>
							{renderEditItems(getMainCategory(), true)}
						</div>

						{filteredSubCategoryList
							?.filter((category) => !category?.isPrimary)
							?.map((item) => (
								<div
									className="configuration-single d-flex justify-content-between align-items-center align-self-center"
									key={item?.id}
								>
									<div
										className=" d-flex justify-content-start"
										onClick={() => navigate(`/pom-tag-list/${item?.id}`)}
									>
										<div className="dress-img">
											<img
												src={
													item?.documentResponse?.docUrl ||
													process.env.PUBLIC_URL + '/icons/pom/t-shirt.png'
												}
												alt={item?.name}
											/>

											<div className="hover-img">
												<img
													src={
														item?.documentResponse?.docUrl ||
														process.env.PUBLIC_URL + '/icons/pom/t-shirt.png'
													}
													alt={item?.name}
												/>
											</div>
										</div>
										<div className="configuration-title d-flex justify-content-center align-self-center">
											<p className="regular-14 weight-600 gray_dark_01">{item?.name}</p>
										</div>
									</div>
									{item?.isRangePlanCategory && (
										<span className="active-dot position-absolute bottom-2 left-2"></span>
									)}
									{renderEditItems(item, false)}
								</div>
							))}
					</div>

					{/* dissable-item */}
					<div className="dissable-items pt-3">
						<div className="dissable-title">
							<h3 className="gray_dark_01 semibold-14">
								Disabled sub-category ({disabledSubCategoryList?.length})
							</h3>
						</div>

						<div className="measurement-category-items">
							{disabledSubCategoryList?.map((item) => (
								<div
									className="configuration-single d-flex justify-content-between align-items-center align-self-center dissable"
									key={item?.id}
								>
									<div className=" d-flex justify-content-start">
										<div className="dress-img">
											<img
												src={
													item?.documentResponse?.docUrl ||
													process.env.PUBLIC_URL + '/icons/pom/t-shirt.png'
												}
												alt={item?.name}
											/>
										</div>
										<div className="configuration-title d-flex justify-content-center align-self-center">
											<p className="regular-14 weight-600 gray_dark_01">{item?.name}</p>
										</div>
									</div>
									<div className="edit-items">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle"
													type="button"
													id="menu1"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													<img
														src={`${process.env.PUBLIC_URL}/icons/more_vertical.svg`}
														alt="tee"
													/>
												</button>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													aria-labelledby="menu1"
													x-placement="bottom-end"
												>
													<li
														role="presentation"
														className="px-4 pb-3"
														onClick={() =>
															onUpdateSubCategory({
																...item,
																isDisabled: false
															})
														}
													>
														<span
															role="menuitem"
															className="font-weight-normal  text-black"
														>
															Enable
														</span>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			{actionValue && (
				<AddSubCategory
					parentCategoryId={selectedItem?.id}
					actionValue={actionValue}
					onCloseModal={() => setActionValue(null)}
					onddSuccess={onddSuccess}
					onUpdateSubCategory={onUpdateSubCategory}
				/>
			)}
		</ModalContainer>
	);
};

export default CategoryWiseSubCategoryModal;
